module.exports = __webpack_public_path__ + "img/case_template_grey.b798c8e9.svg";